const theme = {
  colors: {
    primary: "#F5C542",
    primaryDark: "#F29E20",

    secondary: "#E63946",
    secondaryDark: "#FF3C2F",

    accent: "#4A00E0",
    accentLight: "#0575E6",

    text: "#FFFFFF",
    muted: "#A7B1C2",

    bgDark: "#0A0F1D",
    bgDarker: "#02050A",
  },

  gradients: {
    primary: "linear-gradient(90deg, #F5C542, #F29E20)",
    cta: "linear-gradient(90deg, #E63946, #FF3C2F)",
    accent: "linear-gradient(90deg, #4A00E0, #0575E6)",
  },

  maxWidth: "1200px",
};
export default theme;
